import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/seethespin/seethespin/node_modules/next/dist/client/app-dir/link.js");
